<template>
  <div class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">寄送email</h3>
        </div>
        <div class="modal-body" :class="{ 'section-loading': loading_1 }">
          <form class="form">
            <div class="row">
              <div class="col-12">
                <div class="form-group row">
                  <label for="receiver" class="col-3 text-right">收件人</label>
                  <div class="col-7 d-flex flex-column">
                    <input
                      type="text"
                      id="receiver"
                      name="receiver"
                      placeholder="僅能輸入一組Email"
                      v-validate="'required|email'"
                      :class="{ 'is-invalid': errors.has('receiver') }"
                      v-model="form.receiver"
                      class="form-control"
                    />
                    <div
                      class="text-danger d-flex"
                      v-if="errors.has('receiver')"
                    >
                      Email格式有誤
                    </div>
                  </div>
                  <div class="col-2 d-flex">
                    <span class="waring-block d-inline-block ml-2">
                      <span class="text">
                        <span class="text-red">＊</span>
                        必填
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label for="sender" class="col-3 text-right">寄件人</label>
                  <div class="col-4 d-flex flex-column">
                    <input
                      type="text"
                      id="sender"
                      name="sender"
                      placeholder="帳戶名稱"
                      v-validate="'senderTest|required'"
                      :class="{ 'is-invalid': errors.has('sender') }"
                      v-model="form.senderPrefix"
                      @input="senderHandler"
                      class="form-control"
                      maxlength="20"
                    />
                    <div class="text-danger d-flex" v-if="errors.has('sender')">
                      Email格式有誤
                    </div>
                  </div>
                  <div class="col-3 d-flex mt-2">
                    <span v-if="isBnk">@cathaybk.com.tw</span>
                    <span v-else>@cathaylife.com.tw</span>
                  </div>
                  <div class="col-2">
                    <span class="waring-block d-inline-block ml-2">
                      <span class="text">
                        <span class="text-red">＊</span>
                        必填
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label for="sender" class="col-3 text-right"
                    >副件收件人</label
                  >
                  <div class="col-7 d-flex flex-column">
                    <input
                      type="text"
                      id="receivercc"
                      name="receivercc"
                      placeholder="僅能輸入一組Email"
                      v-validate="'email'"
                      :class="{ 'is-invalid': errors.has('receivercc') }"
                      v-model="form.receivercc"
                      class="form-control"
                    />
                    <div
                      class="text-danger d-flex"
                      v-if="errors.has('receivercc')"
                    >
                      Email格式有誤
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label for="sender" class="col-3 text-right"
                    >密件副件收件人</label
                  >
                  <div class="col-7 d-flex flex-column">
                    <input
                      type="text"
                      id="receiverbcc"
                      name="receiverbcc"
                      placeholder="僅能輸入一組Email"
                      v-validate="'email'"
                      :class="{ 'is-invalid': errors.has('receiverbcc') }"
                      v-model="form.receiverbcc"
                      class="form-control"
                    />
                    <div
                      class="text-danger d-flex"
                      v-if="errors.has('receiverbcc')"
                    >
                      Email格式有誤
                    </div>
                  </div>
                  <!-- <div class="col-2 d-flex">
                    <span class="waring-block d-inline-block ml-2">
                      <span class="text"
                        ><span class="text-red">＊</span>必填</span
                      >
                    </span>
                  </div>-->
                </div>
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <label for="sender" class="col-3 text-right">主旨</label>
                  <div class="col-7 d-flex flex-column">
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      v-validate="'subjectTest|required'"
                      :class="{ 'is-invalid': errors.has('subject') }"
                      v-model="form.subject"
                      class="form-control"
                    />
                    <div
                      class="text-danger d-flex"
                      v-if="errors.has('subject')"
                    >
                      主旨格式有誤
                    </div>
                  </div>
                  <div class="col-2 d-flex">
                    <span class="waring-block d-inline-block ml-2">
                      <span class="text">
                        <span class="text-red">＊</span>
                        必填
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="text-right">
            <a @click="doCancel" class="btn btn-default editbtn mr-3">取消</a>
            <a @click="doSend" class="btn btn-primary editbtn">傳送</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VeeValidate, { Validator } from "vee-validate";
import { getAgntInfo } from "@/service";
export default {
  name: "SendEmailModal",
  data() {
    return {
      loading_1: false,
      form: {
        receiver: "",
        senderPrefix: "",
        sender: "",
        senderName: this.senderName,
        receivercc: "",
        receiverbcc: "",
        subject: this.getSubjectText(),
      },
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    isBnk: {
      type: Boolean,
      default: false,
    },
    senderName: {
      type: String,
      default: "",
    }
  },

  created() {
    let getMessage = (field) => `${field} 格式不正確`;
    let validate = (value) => {
      return !value.includes("@");
    };
    const senderTest = {
      getMessage,
      validate,
    };
    Validator.extend("senderTest", senderTest);
    getMessage = (field) => `${field} 格式不正確`;
    validate = (value) => {
      return this.len(value) > 50 ? false : true;
    };
    const subjectTest = {
      getMessage,
      validate,
    };
    Validator.extend("subjectTest", subjectTest);
  },
  watch: {
    open: function (newValue) {
      if (newValue) {
        this.resetForm();
      }
    },
  },
  methods: {
    getSubjectText() {
      let path = this.$route.path;
      let subjectText = "";
      if(path.indexOf("create") != -1) {
        subjectText = "國泰人壽個人資料保護法應告知事項";
      } else if(path.indexOf("relationship") != -1) {
        subjectText = "國泰人壽增值回饋分享金試算表";
      }
      return subjectText;
    },

    len(str) {
      return str.replace(/[^\x00-\xff]/g, "xx").length;
    },
    doCancel() {
      this.$emit("close");
      this.$validator.reset();
      this.resetForm();
    },
    doSend() {
      this.$validator.validateAll().then((el) => {
        if (el) {
          this.$emit("close");
          this.$emit("doSendEmail", this.form);
          this.$validator.reset();
          // this.resetForm();
        }
      });
    },
    resetForm() {
      this.form = {
        receiver: "",
        senderPrefix: "",
        sender: "",
        senderName: this.senderName,
        receivercc: "",
        receiverbcc: "",
        subject: this.getSubjectText(),
      };
    },
    senderHandler(event){
      let senderInput = event.target.value
      this.senderPrefix = senderInput
      if(this.isBnk){
        senderInput += '@cathaybk.com.tw' 
      }else{
        senderInput += '@cathaylife.com.tw'
      }
      this.form.sender = senderInput
    }
  },
};
</script>
<style scoped>
.modal.fade .modal-body {
  min-height: auto;
}

.editbtn {
  width: 120px;
  height: 40px;
}

.editbtnFont {
  width: 100px;
  height: 22px;
  font-family: PingFangTC;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.fontType {
  font-family: PingFangTC;
}
</style>